// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { createStore } from 'vuex';
import app from './modules/app';
import auth from './modules/auth';
import reprogram from './modules/reprogram';
import vehicle from './modules/vehicle';
import cache from './modules/cache';
import netAppConnector from './modules/netAppConnector';
import targetUnit from './modules/targetUnit';
import table from './modules/table';
import observation from './modules/observation';
import immobilizer from './modules/immobilizer';
import macKey from './modules/macKey';
import obd from './modules/obd';

// 共通Store
import userProperty from '../share/store/userProperty';
import fileResources from '../share/store/fileResources';
import masterResources from '../share/store/masterResources';
import systems from '../share/store/systems';
import provider from '../share/store/provider';

const initialState = {
  app: { ...app.state },
  auth: { ...auth.state },
  reprogram: { ...reprogram.state },
  userProperty: { ...userProperty.state },
  masterResources: { ...masterResources.state },
  vehicle: { ...vehicle.state },
  cache: { ...cache.state },
  netAppConnector: { ...netAppConnector.state },
  targetUnit: { ...targetUnit.state },
  table: { ...table.state },
  immobilizer: { ...immobilizer.state },
  macKey: { ...macKey.state },
  obd: {...obd.state },
  // 以下の情報はreset(ログアウト時)に初期化しない 
  //fileResources: { ...fileResources.state },
  //systems: { ...systems.state },
  //provider: { ...provider.state },
};

// 車両情報取得前の状態
const initialVehicleState = {
  vehicle: { ...vehicle.state },
  netAppConnector: { ...netAppConnector.state },
};

export default createStore({
  modules: {
    app,
    auth,
    reprogram,
    userProperty,
    fileResources,
    masterResources,
    systems,
    vehicle,
    cache,
    netAppConnector,
    targetUnit,
    table,
    observation,
    immobilizer,
    macKey,
    obd,
    provider,
  },
  mutations: {
    reset(state) {
      Object.keys(initialState).forEach(key => {
        Object.assign(state[key], initialState[key]);
      });
    },

    resetVehicleState(state) {
      Object.keys(initialVehicleState).forEach(key => {
        Object.assign(state[key], initialVehicleState[key]);
      });
    }
  },
  actions: {
    reset(context) {
      context.commit('reset');
    },

    resetVehicleState(context) {
      context.commit('resetVehicleState');
    }
  }
});